import { render, staticRenderFns } from "./FileCirclePlusFilled.vue?vue&type=template&id=61c97417&"
import script from "./FileCirclePlusFilled.vue?vue&type=script&lang=js&"
export * from "./FileCirclePlusFilled.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports